import React from 'react';
import { Link } from "react-router-dom";
import UbicacionCompoent from '../components/UbicacionComponent'


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button } from 'react-bootstrap';
import FranjaCotizar from '../components/FranjaCotizar';
import RecorridoVirtual from '../components/RecorridoVirtual';

const Inicio = () => {

    const heroSlide = {
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };

    const contenidoSlide = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };

    const exploraSlide = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };


    return (
        <div className='page home'>

            <section id='hero-phone'>
                <div className='logo'>
                    <img
                        src="/images/home/Logo_1_celular.png"
                        alt="icono_1_celular"
                    />
                </div>

                <div className='contenido'>
                    <div className='arriba'>DESCUBRE TU NUEVA INVERSIÓN</div>
                    <div className='medio'>CON LA VANGUARDIA DE LA ARQUITECTURA MODERNA</div>
                    <div className='abajo'>Maximiza tu inversión con altos rendimientos en Airbnb</div>
                </div>
            </section>

            <section id='hero'>
                <div className='slide-hero'>
                    <Slider {...heroSlide}>
                        <div className='item'>
                            <div className='contenido'>
                                <p className='texto'>DESCUBRE TU <span>NUEVA INVERSIÓN</span></p>
                                <p className='texto-1'>CON LA <span> VANGUARDIA DE</span> <span>LA ARQUITECTURA MODERNA</span></p>
                                <p className='texto-small'>Maximiza tu inversión con <span>altos rendimientos en Airbnb</span></p>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='contenido'>
                                <p className='texto'>DESCUBRE TU <span>NUEVA INVERSIÓN</span></p>
                                <p className='texto-1'>CON LA <span> VANGUARDIA DE</span> <span>LA ARQUITECTURA MODERNA</span></p>
                                <p className='texto-small'>Maximiza tu inversión con <span>altos rendimientos en Airbnb</span></p>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='contenido'>
                                <p className='texto'>DESCUBRE TU <span>NUEVA INVERSIÓN</span></p>
                                <p className='texto-1'>CON LA <span> VANGUARDIA DE</span> <span>LA ARQUITECTURA MODERNA</span></p>
                                <p className='texto-small'>Maximiza tu inversión con <span>altos rendimientos en Airbnb</span></p>
                            </div>
                        </div>
                    </Slider>

                    <div className='texto-abajo'>
                        <p className='big'>CONOCE</p>
                        <p className='small'>NUESTRO PILOTO</p>
                    </div>
                </div>
                <div className='tablet'>
                    <FranjaCotizar />
                </div>
                <div className='fondo'></div>
            </section>
            <div className='note'>
                <FranjaCotizar />
            </div>
            <section id='banner-recorrido'>
                <div className='banner'>
                    <div className='titulo'>
                        <p className='big'>VIVE EL ESTILO</p>
                        <p className='small'>RECORRIDO VIRTUAL</p>
                    </div>

                    <div className='contenido'>
                        <img
                            src={"/images/home/icono_1_tablet.png"}
                            alt='icono recorrido 360°'
                        />

                        <Link to="/recorre">
                            <Button variant="primary">
                                RECORRE
                            </Button>
                        </Link>
                    </div>
                </div>

                <div className='fondo'></div>
            </section>

            <section id='banner-contenido'>
                <div className='slide'>
                    <Slider {...contenidoSlide}>
                        <div className='item'>
                            <div className='tablet'>
                                <img
                                    src={"/images/home/contenido_2_slide_1_tablet.png"}
                                    alt='slide imagen 1'
                                />
                            </div>
                            <div className='note'>
                                <img
                                    src={"/images/home/contenido_2_slide_1_escritorio.png"}
                                    alt='slide imagen 1'
                                />
                            </div>
                        </div>
                        <div className='item'>
                            <div className='tablet'>
                                <img
                                    src={"/images/home/contenido_2_slide_2_tablet.png"}
                                    alt='slide imagen 2'
                                />
                            </div>
                            <div className='note'>
                                <img
                                    src={"/images/home/contenido_2_slide_2_escritorio.png"}
                                    alt='slide imagen 1'
                                />
                            </div>
                        </div>
                        <div className='item'>
                            <div className='tablet'>
                                <img
                                    src={"/images/home/contenido_2_slide_3_tablet.png"}
                                    alt='slide imagen 3'

                                />
                            </div>
                            <div className='note'>
                                <img
                                    src={"/images/home/contenido_2_slide_3_escritorio.png"}
                                    alt='slide imagen 1'

                                />
                            </div>
                        </div>
                        <div className='item'>
                            <div className='tablet'>
                                <img
                                    src={"/images/home/contenido_2_slide_4_tablet.png"}
                                    alt='slide imagen 4'
                                />
                            </div>
                            <div className='note'>
                                <img
                                    src={"/images/home/contenido_2_slide_4_escritorio.png"}
                                    alt='slide imagen 1'
                                />
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

            <section id='banner-explora'>
                <div className='arriba'>
                    <div className='in'>
                        <p className='titulo'>DESLÚMBRATE</p>
                        <p className='texto'>CON LA ARQUITECTURA MODERNA Y APROVECHA SU POTENCIAL PARA OBTENER INGRESOS ADICIONALES</p>
                    </div>

                    <p className='texto-ver-plantas'>VISITA NUESTRAS PLANTAS</p>

                    <Link to="/plantas">
                        <Button variant="primary">
                            Explora
                        </Button>
                    </Link>

                </div>
                <div className='slide-explora'>
                    <div className='cabecera'>
                        <p className='big'>DISEÑO Y VANGUARDIA</p>
                        <p className='small'>EN TERMINACIONES Y MATERIALES</p>
                    </div>
                    <Slider {...exploraSlide}>
                        <div className='item'>
                            <div className='fondo fondo-1'>
                                <div className='franja'>Cubiertas de Granito</div>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='fondo fondo-2'>
                                <div className='franja'>Cubiertas de Granito</div>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='fondo fondo-3'>
                                <div className='franja'>Cubiertas de Granito</div>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='fondo fondo-4'>
                                <div className='franja'>Cubiertas de Granito</div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

            <RecorridoVirtual />

            <UbicacionCompoent />
        </div>
    )
}

export default Inicio